function HomeController(){
	this.className			= "HomeController";
	this.view				= false;
	this.glob				= ["/", "/?**"];
	this.viewData			= {};
}
HomeController.inheritsFrom( PageController );
HomeController.prototype.on = function(onComplete){
	this.$html          	= $('html');
	this.$body				= $('body');
	this.$logo 				= this.$body.find('.js-slash-screen--logo');
	this.$slideshow 		= this.$body.find('.js-slideshow');

	// gsap.registerPlugin(ScrollTrigger);
	// gsap.registerPlugin(CustomEase);
	this.timeline = gsap.timeline();

	this.gsapAnimations = [];
	this.animationGroups = [];

	// this.setupLogoAnimation();

	this.setupAnimations();
	this.setupSlideshow();
	this.setupHeroLogo();
	this.setupStudioParallax();
	this.setupServicesParallax();

	// Setup mousemove effects (only if target exists).
	// NOTE: Avoid creating a new tween on every mousemove; use quickTo setters instead.
	this.$studioWordTargets = this.$body.find('#studio .js-animate--word');
	if (this.$studioWordTargets.length) {
		this._studioWordSetSerif = gsap.quickTo(this.$studioWordTargets, "--font-serif", {
			duration: 0.25,
			ease: "power3.out",
			overwrite: true,
		});
		this._studioWordSetSlant = gsap.quickTo(this.$studioWordTargets, "--font-slant", {
			duration: 0.25,
			ease: "power3.out",
			overwrite: true,
		});

		this.mousemoveEvent = (e) => this.onMousemove(e);
		window.addEventListener("mousemove", this.mousemoveEvent, { passive: true });
	}

	return true;
}
HomeController.prototype.onMousemove = function(e) {
	if (!this._studioWordSetSerif || !this._studioWordSetSlant) return;

	const moveY = (e.clientY / (window.innerHeight));
	const moveX = (e.clientX / (window.innerWidth));

	this._studioWordSetSerif(moveX); // 0 to 1
	this._studioWordSetSlant((moveY * 14) - 14); // -14 to 0 (moveY * 14) - 14 (-14 to 0)
}

HomeController.prototype.setupHeroLogo = function() {
	const $heroLogo = this.$body.find('.site-logo--hero');
	const $headerLogo = this.$body.find('.site-header .site-logo').not('.site-logo--hero').first();
	const $headerBackdrop = this.$body.find('.site-header__backdrop').first();
	const $logoContainer = this.$body.find('.js-logo-container');
	const $logoSpacer = this.$body.find('.js-logo-spacer');
	
	if (!$heroLogo.length || !$headerLogo.length) return;
	
	const $heroLogoImage = $heroLogo.find('.site-logo__image img');
	const $headerLogoImage = $headerLogo.find('.site-logo__image img');
	
	// Variables for sizes
	let h1 = 0; // Size of .site-logo .site-logo__image img in .site-header
	let h2 = 0; // Size of .site-logo--hero .site-logo__image img
	
	// Position variables
	const bottom = 0;
	const top = 1;
	const blurHandoffBuffer = 4;
	
	// Store initial hero logo position
	let heroLogoInitialTop = 0;
	
	// Function to measure sizes
	const measureSizes = () => {
		// h1: Measure header logo height (should be stable)
		const measuredH1 = $headerLogoImage.height();
		if (measuredH1 > 0) {
			h1 = measuredH1;
		}
		
		// h2: Measure hero logo natural/original height
		// Temporarily remove inline height to get the natural rendered height
		const currentHeroHeight = $heroLogoImage.css('height');
		const heroImageElement = $heroLogoImage[0];
		
		// Remove inline height style
		heroImageElement.style.height = '';
		
		// Force a reflow to ensure the browser recalculates the layout
		heroImageElement.offsetHeight;
		
		// Now measure the natural height
		const measuredH2 = $heroLogoImage.height();
		if (measuredH2 > 0) {
			h2 = measuredH2;
		}
		
		// Restore the height if it was set (but only if it was a pixel value)
		if (currentHeroHeight && currentHeroHeight !== 'auto' && currentHeroHeight !== 'none' && currentHeroHeight !== '') {
			heroImageElement.style.height = currentHeroHeight;
		}
	};

	// Function to get the initial document position of hero logo
	const getHeroLogoInitialTop = () => {
		// Check if logo is currently fixed
		const currentPosition = window.getComputedStyle($heroLogo[0]).position;
		const isFixed = currentPosition === 'fixed';
		
		if (isFixed) {
			// If fixed, temporarily switch to relative to get correct document position
			const currentStyles = {
				position: $heroLogo.css('position'),
				top: $heroLogo.css('top'),
				left: $heroLogo.css('left'),
				transform: $heroLogo.css('transform'),
				zIndex: $heroLogo.css('z-index')
			};
			
			// Temporarily set to relative
			$heroLogo.css({
				'position': 'relative',
				'top': 'auto',
				'left': 'auto',
				'transform': 'none',
				'z-index': '2'
			});
			
			// Force reflow
			$heroLogo[0].offsetHeight;
			
			// Get the document position
			const heroLogoRect = $heroLogo[0].getBoundingClientRect();
			const initialTop = heroLogoRect.top + window.scrollY;
			
			// Restore original styles
			$heroLogo.css(currentStyles);
			
			// Force reflow again
			$heroLogo[0].offsetHeight;
			
			return initialTop;
		} else {
			// If relative, can calculate normally
			const heroLogoRect = $heroLogo[0].getBoundingClientRect();
			return heroLogoRect.top + window.scrollY;
		}
	};

	// Function to get scroll position between 0 and 1
	const getScrollProgress = () => {
		// Get current positions
		const heroLogoRect = $heroLogo[0].getBoundingClientRect();
		const headerLogoRect = $headerLogo[0].getBoundingClientRect();
		
		// Get the top position of header logo (fixed, so viewport position)
		const headerLogoTop = headerLogoRect.top;
		
		// Get the initial document position of hero logo
		// Recalculate if we're at the top of the page (scrollY === 0) or if it hasn't been set
		if (heroLogoInitialTop === 0 || window.scrollY === 0) {
			heroLogoInitialTop = getHeroLogoInitialTop();
		}
		
		// Calculate scroll distance needed for hero logo to reach header logo position
		// When scrollY = heroLogoInitialTop - headerLogoTop, hero logo top will be at headerLogoTop
		const scrollDistance = heroLogoInitialTop - headerLogoTop;
		
		// Current scroll position
		const currentScroll = window.scrollY;
		
		// Calculate progress (0 to 1)
		// n = 0 when at bottom (initial position, currentScroll = 0)
		// n = 1 when hero logo reaches header logo position (currentScroll >= scrollDistance)
		let n = 0;
		
		if (scrollDistance > 0) {
			// Normal case: hero logo starts below header logo
			// Progress from 0 to 1 as we scroll from 0 to scrollDistance
			n = currentScroll / scrollDistance;
		} else if (scrollDistance < 0) {
			// Edge case: hero logo starts above header logo (already past it)
			// Set to 1 immediately
			n = 1;
		} else {
			// Edge case: hero logo starts at header logo position
			// Set to 1 if scrolled, 0 if at top
			n = currentScroll > 0 ? 1 : 0;
		}
		
		// Clamp between 0 and 1
		n = Math.max(0, Math.min(1, n));
		
		return n;
	};
	
	// Function to update spacer height
	const updateSpacerHeight = () => {
		if (!$logoSpacer.length) return;
		
		// Get the height of the hero logo (including padding, margins, etc.)
		const heroLogoHeight = $heroLogo.outerHeight(true);
		
		// Set spacer height to match
		$logoSpacer.css('height', heroLogoHeight + 'px');
	};
	
	// Function to update spacer position based on logo state
	const updateSpacerPosition = (isFixed) => {
		if (!$logoSpacer.length) return;
		
		if (isFixed) {
			// When logo is fixed, spacer should be relative to maintain space
			$logoSpacer.css({
				'position': 'relative',
				'visibility': 'visible'
			});
		} else {
			// When logo is relative, spacer should be absolute (hidden from flow)
			$logoSpacer.css({
				'position': 'absolute',
				'visibility': 'hidden'
			});
		}
	};
	
	// Function to update logo size based on scroll position
	const updateLogoSize = () => {
		const n = getScrollProgress();
		const headerLogoRect = $headerLogo[0].getBoundingClientRect();
		const headerLogoTop = headerLogoRect.top;
		const heroLogoNaturalTop = heroLogoInitialTop - window.scrollY;
		const headerBackdropBottom = $headerBackdrop.length
			? $headerBackdrop[0].getBoundingClientRect().bottom
			: headerLogoTop;
		const isEnteringBackdrop = heroLogoNaturalTop <= (headerBackdropBottom + blurHandoffBuffer);
		
		// Calculate height using formula: h1 * n + h2 * (1 - n)
		const newHeight = h1 * n + h2 * (1 - n);
		
		// Apply height dynamically (width is auto in SCSS)
		$heroLogoImage.css('height', newHeight + 'px');
		
		// Update spacer height whenever logo size changes
		updateSpacerHeight();
		
		// Lift the logo above the header blur as soon as it reaches the blur zone,
		// while clamping it so fast scrolls cannot overshoot the final resting point.
		if (n >= 1 || isEnteringBackdrop) {
			const clampedTop = Math.max(headerLogoTop, heroLogoNaturalTop);

			$heroLogo.css({
				'position': 'fixed',
				'top': clampedTop + 'px',
				'left': '50%',
				'transform': 'translateX(-50%)',
				'z-index': window.getComputedStyle($headerLogo[0]).zIndex || '10'
			});
			
			// Update spacer to relative when logo is fixed
			updateSpacerPosition(true);
		} else {
			// Reset to relative positioning when scrolling back
			$heroLogo.css({
				'position': 'relative',
				'top': 'auto',
				'left': 'auto',
				'transform': 'none',
				'z-index': '2'
			});
			
			// Update spacer to absolute when logo is relative
			updateSpacerPosition(false);
		}
	};
	
	// Wait for images to load before initial measurement
	const initHeroLogoNew = () => {
		// Initial measurement
		measureSizes();
		
		// Get initial position when logo is in relative position (at page load)
		heroLogoInitialTop = getHeroLogoInitialTop();
		
		// Initial spacer setup
		updateSpacerHeight();
		updateSpacerPosition(false); // Initially relative, so spacer is absolute
		
		// Initial update
		updateLogoSize();
	};
	
	// Check if images are already loaded
	if ($heroLogoImage[0].complete && $headerLogoImage[0].complete) {
		initHeroLogoNew();
	} else {
		$heroLogoImage.on('load', initHeroLogoNew);
		$headerLogoImage.on('load', initHeroLogoNew);
		// Fallback timeout
		setTimeout(initHeroLogoNew, 500);
	}
	
	// Measure on resize
	let resizeTimer;
	const handleResize = () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			// Recalculate initial position and sizes
			// getHeroLogoInitialTop() handles the case when logo is fixed
			heroLogoInitialTop = getHeroLogoInitialTop();
			measureSizes();
			
			// Update spacer height on resize
			updateSpacerHeight();
			
			// Update logo size (this will restore fixed position if needed)
			updateLogoSize();
		}, 100);
	};
	window.addEventListener('resize', handleResize);
	
	// Update on scroll
	const handleScroll = () => {
		updateLogoSize();
	};
	window.addEventListener('scroll', handleScroll, { passive: true });
	
	// Store cleanup function
	this.cleanupHeroLogoNew = () => {
		window.removeEventListener('resize', handleResize);
		window.removeEventListener('scroll', handleScroll);
	};
}

HomeController.prototype.setupStudioParallax = function () {
	const $studio = this.$body.find('#studio');
	if (!$studio.length || this._studioParallaxTimeline) return;

	const isMobile = window.matchMedia('(max-width: 767px)').matches;

	const initialOffsetY = isMobile ? 40 : 80;
	const scrub = isMobile ? 0.45 : 0.25;
	const itemDuration = 1;
	const itemStagger = isMobile ? 0.16 : 0.35;
  
	let targets = $studio.find('.row .media').toArray();
	if (!targets.length) return;
  
	// reorder: 2nd, 1st, 4th, 3rd
	if (targets.length >= 4) {
	  targets = [targets[1], targets[0], targets[3], targets[2], ...targets.slice(4)];
	} else if (targets.length >= 2) {
	  targets = [targets[1], targets[0], ...targets.slice(2)];
	}
  
	gsap.set(targets, { y: initialOffsetY, force3D: true });
  
	this._studioParallaxTimeline = gsap.timeline({
	  scrollTrigger: {
		trigger: $studio[0],
	    start: isMobile ? 'top 95%' : 'top 90%',
	    end: isMobile ? 'top 5%' : 'bottom 35%',
		scrub,
		markers: false,
		invalidateOnRefresh: true
	  }
	});
  
	this._studioParallaxTimeline.to(targets, {
	  y: 0,
	  ease: 'sine.out',
	  duration: itemDuration,
	  stagger: itemStagger
	});
  
	ScrollTrigger.refresh();
  
	this.cleanupStudioParallax = () => {
	  if (!this._studioParallaxTimeline) return;
  
	  this._studioParallaxTimeline.scrollTrigger?.kill();
	  this._studioParallaxTimeline.kill();
	  this._studioParallaxTimeline = null;
	};
};

HomeController.prototype.cleanupServicesParallax = function () {
	if (this._servicesParallaxTimeline) {
		this._servicesParallaxTimeline.scrollTrigger?.kill();
		this._servicesParallaxTimeline.kill();
		this._servicesParallaxTimeline = null;
	}

	const items = this.$body?.find('#services ul.weighted-list > li');
	if (items?.length) {
		gsap.set(items.toArray(), { clearProps: 'all' });
	}
};

HomeController.prototype.setupServicesParallax = function () {
	const $services = this.$body.find('#services');
	if (!$services.length) return;

	this.cleanupServicesParallax();

	const titleEl = $services.find('h1').first()[0];
	const items = $services.find('ul.weighted-list > li').toArray();
	if (!titleEl || !items.length) return;

	// Initial state: slightly lower + faded, so we can "pop up" each lozenge.
	gsap.set(items, {
		y: 36,
		opacity: 0,
		scale: 0.985,
		transformOrigin: '50% 100%',
		force3D: true,
	});

	this._servicesParallaxTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: titleEl,
			start: 'top 95%',
			end: () => `+=${Math.max(320, items.length * 90)}`,
			scrub: 0.3,
			markers: false,
			invalidateOnRefresh: true,
		}
	});

	this._servicesParallaxTimeline.to(items, {
		y: 0,
		opacity: 1,
		scale: 1,
		ease: 'power2.out',
		duration: 0.35,
		stagger: 0.07,
	});

	// Re-measure after layout settles (fonts, images, cover fade) on SPA return visits.
	requestAnimationFrame(() => ScrollTrigger.refresh());
};

HomeController.prototype.setupSlideshow = function() {
	this.slides = this.getMeta().slides;
	const template = this.getTemplate("slideshow/slide");
	const $slides = this.$slideshow.find(".js-slides");

	if(this.slides && template) {
		$slides.html("");
		this.slides.forEach((slide) => {
			const compiled = Handlebars.compile(template);
			$slides.append(compiled(slide));
		});
	}

	if (!$slides || !$slides.length) return;
	gsap.set($slides, { autoAlpha: 0 });
	jcache.setImagesSrcWait($slides);

	this.imageController = new ImageController();
	this.imageController.addListener("ready",Igloo.delegate(this, function(){
		if (!$slides || !$slides.length) return;
		gsap.set($slides, {
			autoAlpha: 1, duration: 0, overwrite: true
		});
	}));
	this.imageController.$process($slides);

	// Preloader2.add({src:image});

	// Check if there's only one slide
	const isSingleSlide = this.slides && this.slides.length === 1;

	this.slideshow = new Slideshow({
		wrapper: this.$slideshow,
		delay: 5000,
		initial: isSingleSlide ? false : 5000, // Disable initial delay for single slide
		loop: !isSingleSlide, // Disable loop for single slide
		// slides: this.slides,
		slide: {
			element: 'object',
			on: {
				delay: 0.5,
				duration: 1.2,
				stagger: -0.1,
				ease: 'expo.inOut',
			},
			off: {
				duration: 1.2,
				stagger: -0.1,
				ease: 'expo.inOut',
			}
		},
		caption: {
			on: {
				from: { /*x: '-15%',*/ opacity: 0 },
				to: { /*x: 0,*/ opacity: 1 },
				delay: 0,
				duration: 1,
				ease: 'expo.inOut',
				position: '-=50%' // Animate on 50% of the way through the animation
			},
			off: {
				from: { /*x: 0,*/ opacity: 1 },
				to: { /*x: '15%',*/ opacity: 0 },
				delay: 0,
				duration: 1,
				ease: 'expo.inOut',
				position: '<-=2%' // Animate off at beginning of first animation
			}
		},
	});

	// If single slide, show it immediately without animations
	if (isSingleSlide) {
		// Ensure the slide is visible immediately (CSS should handle this, but ensure it with GSAP)
		const $slide = this.$slideshow.find('.js-slide').first();
		const $objects = $slide.find('.js-object');
		const $caption = $slide.find('.js-caption');
		
		// Wait for images to load, then set final state (visible, no animations)
		// This ensures the slide is permanently visible without any animations
		const showSingleSlide = () => {
			gsap.set($objects, { opacity: 1, x: 0 });
			if ($caption.length) {
				gsap.set($caption, { opacity: 1 });
			}
		};
		
		// Show immediately, then again after a short delay to ensure it stays visible
		showSingleSlide();
		setTimeout(showSingleSlide, 100);
		
		// Don't set up scroll trigger animations for single slide
		return;
	}

	const slideshowAnimation = {
		isReady: false,
		animation: gsap.timeline({
			scrollTrigger: {
				trigger: '#work .js-slideshow',
				markers: false,
				start: 'top 60%',
				end: 'bottom 70%',
				scrub: .5,
				invalidateOnRefresh: true,
				onEnter: () => this.slideshow.play(),
				onLeave: () => this.slideshow.pause(),
				onEnterBack: () => this.slideshow.play(),
				onLeaveBack: () => this.slideshow.pause(),
			}
		})
	};
	this.gsapAnimations.push(slideshowAnimation);
}

HomeController.prototype.setupAnimations = function() {
	//On mobile (like iPhone Safari) → GSAP ignores height-only resizes (toolbar changes)
	ScrollTrigger.config({
		ignoreMobileResize: true
	});

	// ScrollTrigger.addEventListener("refreshInit", () => {
	// 	console.log("🔄 refreshInit");
	// 	console.trace(); // 👈 shows exactly what caused it
	// });

	const containerSelector = '.js-section';
	const titleSelector     = '.js-animate--title';
	// const imageSelector     = '.js-intro--image';

	// const userAgent = navigator.userAgent;
	// const isIPhoneSafari = /iPhone/i.test(userAgent)
	// 	&& /Safari/i.test(userAgent)
	// 	&& !/CriOS|FxiOS|EdgiOS/i.test(userAgent);

	// Disable these text animations entirely on iPhone Safari for testing.
	// if (isIPhoneSafari) return;

	const settings = {
		delay: 0,
		duration: 1.8,//2.5,
		// ease: CustomEase.create("custom", "0.565, 0.150, 0.435, 0.810"),
		// ease: CustomEase.create("custom", "0.420, 0.000, 0.580, 1.000"),
		// ease: CustomEase.create("custom", "0.510, 0.010, 0.490, 1.000"),
		//ease: CustomEase.create("custom", "0.795, 0.275, 0.210, 0.785"),
		ease: CustomEase.create("custom", "0.75 0.000, 0.25, 1.000"),
	}

	const triggerStart = "top 80%";
	const triggerEnd = "top 80%";

	const animationTimeline = [
		{
			selector: '.text-style--2',
			triggerStart: triggerStart,
			triggerEnd: triggerEnd,
			showMarkers: false,
			items: [{
				selector: '.text-style--2 span',
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: -14, end: 0 },
					'--font-serif': { start: 0, end: .76 }
				},
				...settings,
			}],
			onScroll: false,
		},{
			selector: '.text-style--3',
			triggerStart: triggerStart,
			triggerEnd: triggerEnd,
			showMarkers: false,
			items: [{
				selector: '.text-style--3 span:nth-of-type(1)',
				props: {
					'--font-weight': { start: 700, end: 400 },
					'--font-slant': { start: -14, end: 0 },
					'--font-serif': { start: 1, end: 0 }
				},
				...settings,
			},{
				selector: '.text-style--3 span:nth-of-type(2)',
				props: {
					'--font-weight': { start: 200, end: 400 },
					'--font-slant': { start: -14, end: 0 },
					'--font-serif': { start: 0, end: 0 }
				},
				...settings,
			}],
			onScroll: false,
		},{
			selector: '.text-style--4',
			triggerStart: triggerStart,
			triggerEnd: triggerEnd,
			showMarkers: false,
			items: [{
				selector: '.text-style--4 span',
				props: {
					'--font-weight': { start: 700, end: 100 },
					'--font-slant': { start: 0, end: 0 },
					'--font-serif': { start: 1, end: 0.01 },
					// '--font-letter-spacing': { start: '-0.02em', end: '0.01em' }
				},
				...settings,
			}],
			onScroll: false,
		},
	];

	/*
	animationTimeline.push({
		selector: '#section-4 .page-content',
		triggerStart: "bottom 100%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `.text-style--4`,
			start: { x: 0, y: -80 },
			end: { x: 0, y: 80 },
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	animationTimeline.push({
		selector: '#section-4 .page-content',
		triggerStart: "bottom 100%",
		triggerEnd: "bottom 80%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `.text-style--4`,
			props: {
				opacity: { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#section-4 .page-content',
		triggerStart: "top 20%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `.text-style--4`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	*/

	animationTimeline.forEach((animation) => {
		// console.log(animation, $(animation.selector).id);

		const animationGroup = new GsapController({
			containerSelector: animation.selector,
			items: animation?.items,
			triggerStart: animation?.triggerStart,
			triggerEnd: animation?.triggerEnd,
			showMarkers: animation?.showMarkers,
			toggleActions: animation?.toggleActions,
			scrub: 0.5,
			onScroll: animation?.onScroll,
		});
		this.animationGroups.push(animationGroup);
	});
}


HomeController.prototype.setupLogoAnimation = function() {
	const containerSelector = '.js-intro';
	const titleSelector     = '.js-intro--title';
	const imageSelector     = '.js-intro--image';

	this.logoAnimationTimeline = [
		//--- DESIRE
		{
			selector: '#desire',
			triggerStart: "top 100%",
			triggerEnd: "bottom 100%",
			showMarkers: false,
			items: [{
				selector: '#desire',
				start: { x: 0, y: 80 },
				end: { x: 0, y: 0 },
				props: {},
				duration: 2,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		},
		{
			selector: '#desire .js-intro--title:nth-of-type(1)',
			triggerStart: "top 100%",
			triggerEnd: "bottom 0%",
			showMarkers: false,
			items: [{
				selector: '#desire .js-intro--title:nth-of-type(1)',
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		},
		{
			selector: '#desire .js-intro--title:nth-of-type(2)',
			triggerStart: "top 100%",
			triggerEnd: "bottom 0%",
			showMarkers: false,
			items: [{
				selector: '#desire .js-intro--title:nth-of-type(2)',
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		},
		{
			selector: '#desire .js-intro--title:nth-of-type(3)',
			triggerStart: "top 100%",
			triggerEnd: "bottom 0%",
			showMarkers: false,
			items: [{
				selector: '#desire .js-intro--title:nth-of-type(3)',
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		},
		{
			selector: '#desire .js-intro--title:nth-of-type(4)',
			triggerStart: "top 100%",
			triggerEnd: "bottom 0%",
			showMarkers: false,
			items: [{
				selector: '#desire .js-intro--title:nth-of-type(4)',
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		},
		{
			selector: '#desire .js-intro--title:nth-of-type(5)',
			triggerStart: "top 100%",
			triggerEnd: "bottom 0%",
			showMarkers: false,
			items: [{
				selector: '#desire .js-intro--title:nth-of-type(5)',
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		},
		//--- WORK
		/*
		{
			selector: '#work',
			triggerStart: "top 90%",
			triggerEnd: "top 10%",
			showMarkers: false,
			items: [{
				selector: `#work ${titleSelector}`,
				props: {
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power4.inOut',
			}]
		},*/
		//--- STUDIO
		{
			selector: '#studio .js-intro--title',
			triggerStart: "top 100%",
			triggerEnd: "top 10%",
			showMarkers: false,
			items: [{
				selector: `#studio .js-title--top`,
				props: {
					'--font-weight': { start: 700, end: 450 },
					'--font-serif': { start: 1, end: .5 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power4.inOut',
			},
			{
				selector: `#studio .js-title--bottom`,
				props: {
					'--font-weight': { start: 200, end: 450 },
					'--font-serif': { start: 0, end: .5 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power4.inOut',
			}]
		},
		//--- PORTFOLIO
		/*
		{
			selector: '#portfolio',
			triggerStart: "top 90%",
			triggerEnd: "top 10%",
			showMarkers: false,
			items: [{
				selector: `#studio ${titleSelector}`,
				props: {
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power4.inOut',
			}]
		}
		*/
		//--- TECHNOLOGY
		{
			selector: `#technology ${titleSelector}`,
			triggerStart: "top 60%",
			triggerEnd: "top 0%",
			showMarkers: false,
			items: [{
				selector: `#technology ${titleSelector}`,
				props: {
					//'letter-spacing': { start: '0px', end: '-1px' },
					'--font-weight': { start: 700, end: 200 },
					opacity: { start: 1, end: 0 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power4.inOut',
			}]
		},
	];

	this.logoAnimationTimeline.forEach((animation) => {
		//console.log(animation, $(animation.selector).id);

		const animationGroup = new GsapController({
			containerSelector: animation.selector,
			items: animation?.items,
			triggerStart: animation?.triggerStart,
			triggerEnd: animation?.triggerEnd,
			showMarkers: animation?.showMarkers,
			scrub: 0.5,
		});
		this.animationGroups.push(animationGroup);
	});
}
HomeController.prototype.updateAnimationGroups = function(imageIndex) {
	this.animationGroups[imageIndex].calculateContainerBaseDimensions();
}
HomeController.prototype.off = function() {
	if(this.mousemoveEvent) window.removeEventListener("mousemove", this.mousemoveEvent);
	this.mousemoveEvent = null;
	this._studioWordSetSerif = null;
	this._studioWordSetSlant = null;
	this.$studioWordTargets = null;

	if(this.slideshow) this.slideshow.destroy();
	if(this.cleanupHeroLogoNew) this.cleanupHeroLogoNew();
	if(this.cleanupStudioParallax) this.cleanupStudioParallax();
	if(this.cleanupServicesParallax) this.cleanupServicesParallax();

	if (typeof ScrollTrigger !== 'undefined') {
		ScrollTrigger.killAll();
	}
}
